<section class="offline" id="offline">
  <div class="offline__grid"></div>
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>

  <div class="container">
    <div class="offline__header">
      <span class="section-tag">{{ t().offline_tag }}</span>
      <h2 class="section-title">{{ t().offline_title }}<br><span>{{ t().offline_subtitle }}</span></h2>
      <p class="section-subtitle" style="max-width: 500px; margin: 16px auto 0;">
        {{ t().offline_feat1_desc }}
      </p>
    </div>

    <div class="offline__icon">
      <svg viewBox="0 0 200 200" class="satellite-icon">
        <!-- Orbit rings -->
        <ellipse cx="100" cy="100" rx="85" ry="30" stroke="rgba(0,102,204,0.2)" stroke-width="1" fill="none" class="orbit-1"/>
        <ellipse cx="100" cy="100" rx="70" ry="25" stroke="rgba(0,102,204,0.15)" stroke-width="1" fill="none" class="orbit-2" transform="rotate(45 100 100)"/>
        <!-- Earth -->
        <circle cx="100" cy="100" r="25" fill="rgba(0,102,204,0.15)" stroke="rgba(0,102,204,0.3)" stroke-width="1.5"/>
        <path d="M80 100 Q90 85 100 100 Q110 115 120 100" stroke="rgba(0,212,255,0.4)" stroke-width="1.5" fill="none"/>
        <path d="M85 90 Q100 80 115 90" stroke="rgba(0,212,255,0.3)" stroke-width="1" fill="none"/>
        <!-- Satellite -->
        <g class="satellite">
          <rect x="145" y="35" width="14" height="8" rx="2" fill="#0066cc"/>
          <rect x="149" y="30" width="6" height="18" rx="1" fill="rgba(255,255,255,0.15)"/>
          <line x1="148" y1="35" x2="145" y2="32" stroke="#0066cc" stroke-width="2"/>
          <line x1="156" y1="35" x2="159" y2="32" stroke="#0066cc" stroke-width="2"/>
        </g>
        <!-- Signal waves -->
        <path d="M140 50 Q130 60 125 75" stroke="#22c55e" stroke-width="1.5" fill="none" class="signal-wave" opacity="0.6"/>
        <path d="M135 45 Q120 55 115 70" stroke="#22c55e" stroke-width="1" fill="none" class="signal-wave" opacity="0.4" transform="rotate(10 135 45)"/>
        <!-- Check mark -->
        <circle cx="100" cy="100" r="15" fill="rgba(34,197,94,0.1)" stroke="#22c55e" stroke-width="1.5"/>
        <path d="M93 100l5 5 9-9" stroke="#22c55e" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>

    <div class="offline__features">
      <div class="offline-card" *ngFor="let f of features()">
        <div class="offline-card__num">{{ f.num }}</div>
        <h3>{{ f.title }}</h3>
        <p>{{ f.desc }}</p>
      </div>
    </div>
  </div>
</section>